import { Point } from "./point";
import { Size } from "./size";

export class Rectangle {
    x: number;
    y: number;
    height: number;
    width: number;

    constructor(x: number, y: number, width: number, height: number) {
        this.x = x;
        this.y = y;
        this.height = height;
        this.width = width;
    }

    center(): Point {
        let point = new Point(this.x + this.width / 2, this.y + this.height / 2);
        return point;
    }

    size(): Size {
        return new Size(this.width, this.height);
    }

    multiply(size: Size): Rectangle {
        let newRectangle = new Rectangle(
            this.x * size.width,
            this.y * size.height,
            this.width * size.width,
            this.height * size.height,
        );
        this.round()
        return newRectangle;
    }

    isSmallNumber(n: number) {
        return Math.abs(n) < 1;
    }
    round() {
        if (this.isSmallNumber(this.x) &&
            this.isSmallNumber(this.x) &&
            this.isSmallNumber(this.x) &&
            this.isSmallNumber(this.x)) {
            return
        }

        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);

        this.width = Math.floor(this.width);
        this.height = Math.floor(this.height);
    }

    aspectRatio(): number {
        return this.height / this.width;
    }

    isLandscape(): boolean {
        return this.width >= this.height;
    }

    maxX(): number {
        return this.x + this.width;
    }

    maxY(): number {
        return this.y + this.height;
    }

    maxEdge(): number {
        return Math.max(this.width, this.height);
    }
}
